import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  uploadedFiles: [],
};

const notificationMediaSlice = createSlice({
  name: "notificationMedia",
  initialState,
  reducers: {
    setUploadedFiles(state, action) {
      state.uploadedFiles = action.payload;
    },
    clearUploadedFiles(state) {
      state.uploadedFiles = [];
    },
    addUploadedFile(state, action) {
      state.uploadedFiles.push(action.payload);
    },
    removeUploadedFile(state, action) {
      state.uploadedFiles = state.uploadedFiles.filter(
        (file) => file.uid !== action.payload.uid
      );
    },
  },
});

export const {
  setUploadedFiles,
  clearUploadedFiles,
  addUploadedFile,
  removeUploadedFile,
} = notificationMediaSlice.actions;

export default notificationMediaSlice.reducer;
